import { call, put, takeEvery, select } from 'redux-saga/effects';

import { captureException } from '../../../client/sentry';
import { graphql } from '../../../globals/api/requests';
import { isValidEmail } from '../../account/helpers';
import actions, { CREATE_ALERT_REQUEST } from '../actions/alert';
import { promptToast } from '../../../components/toast-container/actions';
import { SIDEBAR_STATE } from '../constants';

function getNotificationTranslationKey(notifyBy) {
  if (notifyBy.email && notifyBy.push) {
    return 'alert.saved.email_push';
  }
  if (notifyBy.email) {
    return 'alert.saved.email';
  }
  if (notifyBy.push) {
    return 'alert.saved.push';
  }
  return 'alert.saved';
}

function createAlert(productId, options) {
  return graphql(
    `
      mutation alertCreate($productId: Int!, $options: AlertCreateOptions) {
        alertCreate(productId: $productId, options: $options) {
          id
          priceThreshold
          priceStep
          storeGradeThreshold
          alertType
          notifyBy {
            email
            push
          }
          product {
            id
            pathName
          }
        }
      }
    `,
    {
      productId,
      options,
    }
  );
}

function updateAlert(alertId, options) {
  return graphql(
    `
      mutation alertEdit($alertId: Int!, $options: AlertCreateOptions) {
        alertCreate: alertEdit(alertId: $alertId, options: $options) {
          id
          priceThreshold
          priceStep
          storeGradeThreshold
          alertType
          notifyBy {
            email
            push
          }
          product {
            id
            pathName
          }
        }
      }
    `,
    {
      alertId,
      options,
    }
  );
}

export function* createAlertRequest({ data, onSuccess }) {
  const { alertId, productId, email, priceThreshold } = data;
  const { tab } = yield select(state => state.areas.sidebar);
  const { isAuthenticated } = yield select(state => state.areas.account);

  if (!productId && !alertId) {
    yield put(actions.createAlertFailed('error.productId.invalid'));
    return;
  }
  if (email !== undefined && !isValidEmail(email)) {
    yield put(actions.createAlertFailed('error.email.invalid'));
    return;
  }

  const options = data;
  delete options.productId;
  delete options.alertId;
  options.priceThreshold = parseFloat(priceThreshold || 0);
  try {
    const response =
      isAuthenticated && alertId
        ? yield call(updateAlert, alertId, options)
        : yield call(createAlert, productId, options);
    if (response.errors && response.errors.length) {
      yield put(actions.createAlertFailed(response.errors[0].code));
    } else {
      yield put(
        actions.createAlertSuccess(
          response.data.alertCreate.id,
          response.data.alertCreate.product.id
        )
      );
      if (onSuccess) {
        yield call(onSuccess);
      }
      yield put(
        promptToast(
          'success',
          window.APP_GLOBALS.t(
            'product',
            getNotificationTranslationKey(response.data.alertCreate.notifyBy)
          ),
          {
            toastId: productId,
          }
        )
      );
      if (tab !== SIDEBAR_STATE.ALERTS) {
        yield put(actions.openAlerts());
      }
    }
  } catch (e) {
    yield call(captureException, e);
    yield put(actions.createAlertFailed(e.message));
  }
}

function* mySaga() {
  yield takeEvery(CREATE_ALERT_REQUEST, createAlertRequest);
}

export default mySaga;
